import React from "react";
import { MoneyString } from "../../tools/MoneyString";
import Tooltip from "@material-ui/core/Tooltip";
import { Typography } from "@material-ui/core";
import PropTypes from "prop-types";

export default function TotalCostColumn(props) {
  if (props.item.discount_applied !== null) {
    const discountedString =
      props.item.discount_applied.type === "variable"
        ? props.item.discount_applied.amount + "%"
        : MoneyString(props.item.discount_applied.amount);

    return (
      <Tooltip
        title={`Discounted ${discountedString} using code ${props.item.discount_applied.code}`}
        placement="top"
      >
        <div>
          <Typography variant={"caption"} color={"textSecondary"}>
            ({MoneyString(props.item.total_cost)})
          </Typography>{" "}
          {MoneyString(props.item.real_total_cost)}
        </div>
      </Tooltip>
    );
  }
  return MoneyString(props.item.real_total_cost);
}

TotalCostColumn.propTypes = {
  item: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/tables/TotalCostColumn.js